<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title" style="padding: 20px  0 0 0;">Irrevocable Acts</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgment">Acknowledgment</a></li>
<li id="toc-li-5"><a href="#/text/ch005#part-i-the-shape-of-things-familiar">Part I The Shape of Things Familiar</a><ol class="toc"><li id="toc-li-6"><a href="#/text/Section0001#chapter-1">Chapter 1</a></li>
<li id="toc-li-7"><a href="#/text/Section0002#chapter-2">Chapter 2</a></li>
<li id="toc-li-8"><a href="#/text/Section0003#chapter-3">Chapter 3</a></li>
<li id="toc-li-9"><span href="#/text/Section0004#chapter-4" title="Link target outside of Sample">Chapter 4</span></li>
<li id="toc-li-10"><span href="#/text/Section0005#chapter-5" title="Link target outside of Sample">Chapter 5</span></li>
<li id="toc-li-11"><span href="#/text/Section0006#chapter-6" title="Link target outside of Sample">Chapter 6</span></li>
</ol></li>
<li id="toc-li-12"><span href="#/text/ch006#part-ii-conjuring-ghosts" title="Link target outside of Sample">Part II Conjuring Ghosts</span><ol class="toc"><li id="toc-li-13"><span href="#/text/Section0007#chapter-7" title="Link target outside of Sample">Chapter 7</span></li>
<li id="toc-li-14"><span href="#/text/Section0008#chapter-8" title="Link target outside of Sample">Chapter 8</span></li>
<li id="toc-li-15"><span href="#/text/Section0009#chapter-9" title="Link target outside of Sample">Chapter 9</span></li>
<li id="toc-li-16"><span href="#/text/Section0010#chapter-10" title="Link target outside of Sample">Chapter 10</span></li>
<li id="toc-li-17"><span href="#/text/Section0011#chapter-11" title="Link target outside of Sample">Chapter 11</span></li>
<li id="toc-li-18"><span href="#/text/Section0012#chapter-12" title="Link target outside of Sample">Chapter 12</span></li>
<li id="toc-li-19"><span href="#/text/Section0013#chapter-13" title="Link target outside of Sample">Chapter 13</span></li>
<li id="toc-li-20"><span href="#/text/Section0014#chapter-14" title="Link target outside of Sample">Chapter 14</span></li>
<li id="toc-li-21"><span href="#/text/Section0015#chapter-15" title="Link target outside of Sample">Chapter 15</span></li>
<li id="toc-li-22"><span href="#/text/Section0016#chapter-16" title="Link target outside of Sample">Chapter 16</span></li>
<li id="toc-li-23"><span href="#/text/Section0017#chapter-17" title="Link target outside of Sample">Chapter 17</span></li>
<li id="toc-li-24"><span href="#/text/Section0018#chapter-18" title="Link target outside of Sample">Chapter 18</span></li>
</ol></li>
<li id="toc-li-25"><span href="#/text/ch007#part-iii-a-fighting-chance" title="Link target outside of Sample">Part III A Fighting Chance</span><ol class="toc"><li id="toc-li-26"><span href="#/text/Section0019#chapter-19" title="Link target outside of Sample">Chapter 19</span></li>
<li id="toc-li-27"><span href="#/text/Section0020#chapter-20" title="Link target outside of Sample">Chapter 20</span></li>
<li id="toc-li-28"><span href="#/text/Section0021#chapter-21" title="Link target outside of Sample">Chapter 21</span></li>
<li id="toc-li-29"><span href="#/text/Section0022#chapter-22" title="Link target outside of Sample">Chapter 22</span></li>
<li id="toc-li-30"><span href="#/text/Section0023#chapter-23" title="Link target outside of Sample">Chapter 23</span></li>
</ol></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?e5b48514